import { useEffect, useState } from 'react'
import { Slide } from 'react-slideshow-image'
import 'react-slideshow-image/dist/styles.css'

const defaultImages: string[] = [require('@assets/background/60297.jpg'), require('@assets/background/image.png')]
const bannerHeightClassName = 'h-[clamp(150px,26vw,500px)]'
const bannerImageClassName = `block w-full ${bannerHeightClassName} object-fill opacity-70`

interface Props {
  images?: string[]
  singleImage: boolean
}

interface LoadedBanner {
  sourceKey: string
  images: string[]
}

const HeaderBanner = ({ images, singleImage }: Props) => {
  const sourceKey = JSON.stringify(images)
  const [loadedBanner, setLoadedBanner] = useState<LoadedBanner>()

  useEffect(() => {
    if (!images) return

    let active = true
    let image: HTMLImageElement
    const load = (urls: string[], allowFallback: boolean) => {
      image = new Image()
      const markLoaded = () => {
        if (active) setLoadedBanner({ sourceKey, images: urls })
      }
      image.onload = markLoaded
      image.onerror = () => {
        if (!active) return
        if (allowFallback) {
          load(defaultImages, false)
        } else {
          setLoadedBanner({ sourceKey, images: [] })
        }
      }
      image.src = urls[0]
      if (image.complete && image.naturalWidth > 0) markLoaded()
    }

    load(images.length ? images : defaultImages, images.length > 0)
    return () => {
      active = false
      image.onload = null
      image.onerror = null
    }
  }, [images, sourceKey])

  const ready = loadedBanner?.sourceKey === sourceKey && images !== undefined
  const visibleImages = ready ? loadedBanner.images : []
  const slideImages = visibleImages.length === 1 ? [...visibleImages, ...visibleImages] : visibleImages
  const renderImage = (url: string) => (
    <img
      className={bannerImageClassName}
      src={url}
      alt=""
      onError={(event) => {
        if (event.currentTarget.getAttribute('src') !== defaultImages[0]) {
          event.currentTarget.src = defaultImages[0]
        }
      }}
    />
  )

  return (
    <div
      className={`relative w-full ${bannerHeightClassName} overflow-hidden`}
      data-testid="header-banner"
      aria-busy={!ready}
    >
      {!ready && <div role="status" aria-label="Đang tải banner" className="absolute inset-0 bg-[#f3f4f6]" />}
      {visibleImages.length > 0 &&
        (singleImage ? (
          renderImage(visibleImages[0])
        ) : (
          <div className="slide-container">
            <Slide>
              {slideImages.map((url, index) => (
                <div key={`${url}-${index}`}>{renderImage(url)}</div>
              ))}
            </Slide>
          </div>
        ))}
    </div>
  )
}

export default HeaderBanner
